




































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CSelect from '@/components/base/select/CSelect.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import CTable from '@/components/base/table/CTable.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import AIEnum from '@/enums/AIEnum';
import CSearch from '@/components/base/search/CSearch.vue';
import ScheduleSearchDialog from '@/views/journals/ScheduleSearchDialog.vue';

@Component({
    components: {CSearch, CCheckbox, CNumberField, CTable, CDatepicker, CSelect},
})
export default class WarehouseVeneerAuditEditDialogContent extends Vue {
    @Prop() value!: any;
    @Prop() vocabulary!: Map<string, Map<number, string>> | null;

    private data = this.value;
    private aiEnum = AIEnum;
    private searchDialog = ScheduleSearchDialog;

    get headers() {
        let warehousePiece =
            this.data?.IdWarehouseVeneer === null
                ? [
                      {
                          value: 'IdWarehouseVeneer',
                          text: this.$t('Catalogues.Warehouses.WarehouseVeneer.NameSingle'),
                          sortable: true,
                          sort: this.getSelectSort(this.$api.catalogues.warehouseVeneer),
                      },
                  ]
                : [];
        return [
            ...warehousePiece,
            {
                value: 'IdVeneerCategory',
                text: this.$t('Enumeration.VeneerCategory'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerCategory),
            },
            {
                value: 'IdVeneerType',
                text: this.$t('Enumeration.VeneerType'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerType),
            },
            {
                value: 'IdVeneerKind',
                text: this.$t('Enumeration.VeneerKind'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerKind),
            },
            {
                value: 'IdVeneerOuterGrade',
                text: this.$t('Catalogues.Veneers.VeneerOuterGrade.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerOuterGrade),
            },
            {
                value: 'IdVeneerSpecie',
                text: this.$t('Catalogues.Veneers.VeneerSpecie.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerSpecie),
            },
            {
                value: 'IdVeneerSize',
                text: this.$t('Catalogues.Veneers.VeneerSize.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerSize),
            },
            {
                value: 'IdVeneerThickness',
                text: this.$t('Catalogues.Veneers.VeneerThickness.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerThickness),
            },
            {
                value: 'IdVeneerWetness',
                text: this.$t('Catalogues.Veneers.VeneerWetness.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerWetness),
            },
            {
                value: 'IdVeneerPatchingGrade',
                text: this.$t('Catalogues.Veneers.VeneerPatchingGrade.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.veneerPatchingGrade),
            },
            {
                value: 'IdSchedule',
                text: this.$t('Documents.WarehouseVeneerAudit.ProductionShift'),
                sortable: true,
                sort: this.getSelectSort(this.$api.journals.schedule),
                width: 200,
            },
            {
                value: 'NeededShiftCountOfStorage',
                text: this.$t('Documents.PlanInput.NeededShiftCountOfStorage'),
                sortable: true,
            },
            {
                value: 'UsedShiftCountOfStorage',
                text: this.$t('Documents.PlanInput.UsedShiftCountOfStorage'),
                sortable: true,
            },
            {
                value: 'CurrentVolume',
                text: this.$t('Common.CurrentVolume'),
                sortable: true,
            },
            {
                value: 'AuditVolume',
                text: this.$t('Common.ActualVolume'),
                sortable: true,
            },
            {
                value: 'VolumeMeasureUnit',
                text: this.$t('Common.VolumeUnit'),
                sortable: true,
                sort: this.getSelectSort(this.$api.measureUnit),
            },
        ];
    }

    get tableAddData() {
        return {
            IdWarehouseVeneer: this.data.IdWarehouseVeneer,
            IdVeneerCategory: null,
            IdVeneerType: null,
            IdVeneerKind: null,
            IdVeneerOuterGrade: null,
            IdVeneerSpecie: null,
            IdVeneerThickness: null,
            IdVeneerWetness: null,
            IdVeneerPatchingGrade: null,
            IdSchedule: null,
            NeededShiftCountOfStorage: 0,
            UsedShiftCountOfStorage: null,
            CurrentVolume: 0,
            AuditVolume: 0,
            VolumeMeasureUnit: null,
        };
    }

    @Watch('data', {deep: true})
    onDataChange(value: any) {
        this.$emit('input', value);
    }

    getSelectSort(mapKey: string) {
        return (a: number, b: number) => {
            if (this.vocabulary) {
                const A = (this.vocabulary as any).get(mapKey).get(a).order,
                    B = (this.vocabulary as any).get(mapKey).get(b).order;
                return A - B;
            } else return 0;
        };
    }
}
